import { VerifyCodePage } from '@/pages/verify-code';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/verify-code')({
  component: VerifyCodePage,
});
